function getOccupiedIds(referenceDisclaimersMap) {
    return Object.values(referenceDisclaimersMap)
        .map(dis => dis.reference)
        .filter(reference => typeof reference === 'number');
}
function nextIdFromOccupied(occupied) {
    for (let i = 1; i <= occupied.length; i++) {
        if (occupied.indexOf(i) === -1) {
            return i;
        }
    }
    return occupied.length + 1;
}
export function nextId(disclaimers) {
    return nextIdFromOccupied(getOccupiedIds(disclaimers));
}
